import PropTypes from 'prop-types';
import { useState } from 'react';
import { RegularNoteType } from 'components/common/Note/consts';
import { AppBar, IconButton, Toolbar, Typography } from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import { always } from 'ramda';
import { makeStyles } from '@material-ui/core/styles';
import { selectorId } from 'selectors/payerNotes';
import { useSelector, shallowEqual } from 'react-redux';
import NoteEditor from './NoteEditor';

const useStyles = makeStyles((theme) => ({
  appBarPrimaryOverrideColor: {
    backgroundColor: theme.palette.error.light,
  },
  editor: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: theme.spacing(0, 2, 2),
  },
  flex: {
    flex: '1 1 auto',
  },
  overlay: {
    backgroundColor: theme.palette.background.paper,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 1,
  },
}));

const NoteWriter = ({ fspId, payerId, onClose, open }) => {
  const item = useSelector((state) => selectorId(state), shallowEqual);
  const [noteType, setNoteType] = useState(item?.noteType ?? RegularNoteType);
  const classes = useStyles();

  const handleCancel = (event) => onClose(event, false);
  const handleChangeType = (value) => setNoteType(value);
  const handleClose = (event) => onClose(event, true);
  const isRegularNote = noteType === RegularNoteType;
  const appBarColor = isRegularNote ? 'default' : 'primary';
  const title = isRegularNote ? 'Add Note' : 'Add Consumer Notification Note';

  if (!open) {
    return null;
  }

  return (
    <div className={classes.overlay} data-testid="note-writer-panel">
      <AppBar
        classes={{ colorPrimary: classes.appBarPrimaryOverrideColor }}
        color={appBarColor}
        position="static"
      >
        <Toolbar>
          <Typography className={classes.flex} color="inherit" variant="h6">
            {title}
          </Typography>
          <IconButton
            aria-label="Back to notes list"
            color="inherit"
            onClick={handleCancel}
          >
            <KeyboardArrowRight />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className={classes.editor}>
        <NoteEditor
          fspId={fspId}
          payerId={payerId}
          onCancel={handleCancel}
          onChangeType={handleChangeType}
          onSubmit={handleClose}
        />
      </div>
    </div>
  );
};

NoteWriter.propTypes = {
  fspId: PropTypes.number,
  payerId: PropTypes.number,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

NoteWriter.defaultProps = {
  fspId: null,
  payerId: null,
  onClose: always,
  open: false,
};

export default NoteWriter;
